export default __webpack_public_path__ + "static/jbilen-ec69b2087385c08a451d9bc9d0283195.png";